import walletFinancialPositionsMessages from '../../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../../column';
import { TraditionalInsuranceProduct } from '../../traditional-insurance-macro-category';

export const mobileTraditionalInsuranceColumns: Column<TraditionalInsuranceProduct>[] =
  [
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
      key: 'productName',
      type: 'string',
    },
    {
      headerLabel:
        walletFinancialPositionsMessages.tableHeaderTotalPremiumsPaidShort,
      key: 'totalPremiumsPaid',
      type: 'amount',
    },
  ];
